import { ILocalizationState } from './localizationContext';
import { LocalizationActionsTypes, TLocalizationAction } from './localizationActions';

export const localizationReducer = (state: ILocalizationState, action: TLocalizationAction): ILocalizationState => {
	switch (action.type) {
		case LocalizationActionsTypes.REFETCH_WORDINGS:
			return {
				...state,
				needRefetchWordings: action.payload.needRefetchWordings,
			};
		case LocalizationActionsTypes.SET_ALL_DATA:
			return {
				...state,
				groups: action.payload.groups,
			};
		case LocalizationActionsTypes.SET_GROUP:
			return {
				...state,
				selectedGroup: action.payload.selectedGroup,
			};
		case LocalizationActionsTypes.SET_LANGUAGE:
			return {
				...state,
				selectedLanguage: action.payload.selectedLanguage,
			};
		case LocalizationActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
